import { MtmaContact } from './mtma-contact';

export class MtmaUnit {
    Id?: number;
    Contacts: MtmaContactUnit[];
    Description: string;
    Name: string;
    ObjId: string;
    KeyboardCode: string;
    expanded: boolean;
    ContactsInfo: MtmaContactUnit[];
    constructor() {
        this.ContactsInfo = [];
    }
}


export class MtmaContactUnit {
    ContactId: string[];
    RuleId: number;
    DtFrom: string;
    DtTo: string;
    RuleName: string;
    Contact: MtmaContact;
}
